<template>
  <div class="equipment_content">
    <div class="equipment_swiper">
      <div class="recommend">
        <el-carousel width="300px">
          <el-carousel-item
            @click="toDetail(item)"
            v-for="(item, index) in (recommendProductList || '').slice(0,5)"
            :key="index"
          >
            <!-- <img src="../assets/images/needs_bg_1.png" alt="" /> -->
            <div class="carousel_box" style="height: 100%">
              <p class="carousel_tetx">{{ item.title }}</p>
              <img class="carousel_img" :src="item.cover" alt="" @click="click_carousel_img(item.id)" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <ul class="equipment_item">
      <li @click="toDetail(item)" v-for="(item, index) in productList" :key="index">
        <div class="img">
          <img :src="item.cover" alt="" />
        </div>
        <p class="equipment_title">{{ item.title }}</p>
        <span>{{ item.address }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { routerGoNewpage } from "@/utils/index";
export default {
  props: {
    productList: Array,
    recommendProductList: Array,
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
      },
    };
  },
  created() {},
  methods: {
    toDetail(item) {
      routerGoNewpage("/supply_detail", { id: item.id });
    },
    click_carousel_img(id){
      window.open("/supply_detail?id="+id);
    }
  },
};
</script>

<style scoped lang="less">
.swiper-container {
  width: 100%;
  height: 100%;
}
/deep/ .el-carousel__container {
  height: 396px;
}
/deep/.el-carousel__button {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
.carousel_box {
  background: url("../assets/images/swipe.png") no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.carousel_tetx {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  width: 110px;
}
.carousel_img {
  width: 120px !important;
  height: 120px !important;
}
.equipment_content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .recommend {
    width: 142px;
    height: 396px;
  }
  .equipment_swiper {
    height: 396px;
    margin-right: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .equipment_item {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    li {
      width: 24%;
      margin-right: 1%;
      margin-bottom: 15px;
      cursor: pointer;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      .img {
        width: 100%;
        height: 143px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 145px;
      }
      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equipmentList.vue